import { render, staticRenderFns } from "./MainButton.vue?vue&type=template&id=ae7f140a&"
import script from "./MainButton.vue?vue&type=script&lang=ts&"
export * from "./MainButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports